import Vue from 'vue'
import routes from './routes'
import VueRouter from 'vue-router'
import { WSBridge } from '@/utils/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  // base: '/worthpay/partner/',
  // base: '/partner/hybrid/',
  // base: process.env.NODE_ENV === 'production-test' ? '/worthpay/partner/' : '/',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 设置标题
    SyHybridSdk.setNavigationBarTitle({
      params: {
        title: to.meta.title
      },
      success: res => {}
    })
  }
  next()
})
router.afterEach(() => {
  SyHybridSdk.setNavRightBtn({
    params: {
      isShow: 0,
      label: '',
      func() {}
    },
    success: res => {}
  })
})

export default router
